module.exports = __webpack_public_path__ + "statics/img/cate4-2@2x.9b75e1b5.png";